import { lazyRoute } from "@/routes/lazy-route";

const FeatureFlagSettingsPage = lazyRoute(() => import("./feature-flag-settings.page"), "FeatureFlagSettingsPage");

export const featureFlagSettingsRoutes = [
  {
    path: "account/feature-flags",
    element: <FeatureFlagSettingsPage />,
  },
];
